module.exports = "https://ec-cstatic.akulaku.net/mall/growth-publish/_next/static/images/Instagram-f0bf367d45a5c3b6ec5d94d5d873a16a.png";